<template>
  <div>
    <el-card style="margin-bottom:10px"
             shadow="nerver">
      <div class="filter-area">
        <!-- 目的地 -->
        <div>
          <select-dest placeholder="所属目的地"
                       @selectDest="selectDest"></select-dest>
        </div>

        <!-- 搜索 -->
        <el-input size="mini"
                  style="width:20%;margin-left:20px"
                  placeholder="请输入搜索内容"
                  v-model="searchContentKeyword"
                  clearable>
          <el-button slot="append"
                     @click="searchButton"
                     icon="el-icon-search"></el-button>
        </el-input>
        <!-- 新建 -->
        <el-button @click="creatNewTraverContent"
                   size="mini"
                   style="margin-left:auto"
                   type="primary">新建内容</el-button>
      </div>
      <div class="filter-area-tag">
        <select-tag :showTitle="true"
                    :creatNewTag="false"
                    :tagList="contentTags"
                    @getSelectList="getSelectList"></select-tag>
      </div>

    </el-card>
    <el-card shadow="nerver"
             :style="bodyStyle"
             v-loading="loading">
      <card-list :imageHeight="147"
                 buttonName="编辑"
                 titleMiniName="简介："
                 :showDest="false"
                 @clickButton="clickButtonEditor"
                 :cardList="content_list"></card-list>
      <!-- ----------------- 分页 ------------------ -->
      <div class="pagination">
        <el-pagination @current-change="handleCurrentChange_system"
                       :small="true"
                       background
                       layout="prev, pager, next,total"
                       :current-page.sync="pagenum_system"
                       :page-size="pagesize"
                       :total="page_account"></el-pagination>
      </div>
    </el-card>
    <!-- 对话框 -->
  </div>
</template>

<script>
import CardList from '../../components/common/cards/CardsListForContent'
import SelectDest from '../../components/common/select/SelectDest'
import SelectTag from '../../components/common/select/SelectTag'
let clientHeight = document.documentElement.clientHeight
let contentHeight = clientHeight - 150
export default {
  name: 'traver_content',
  components: {
    CardList,
    'select-dest': SelectDest,
    'select-tag': SelectTag,
  },
  data() {
    return {
      loading: true,
      bodyStyle: `min-height: ${contentHeight}px`,
      content_list: [],
      searchContentKeyword: '',
      dest: '',
      contentTags: [], // 标签内容
      tag_list: [],
      // 分页
      pagenum_system: 1, // 当前页
      pagesize: 12, // 每页容量，自行设定
      page_account: null,
    }
  },
  mounted() {
    this.getAllContentTag()
    this.getContentList()
  },
  methods: {
    handleCurrentChange_system(page) {
      this.TripPlanList = []
      this.pagenum_system = page
      this.getContentList()
    },
    // 选择目的地
    selectDest(value) {
      this.dest = value
    },
    // 选择标签
    getSelectList(value) {
      let selectList = []
      value.forEach((i) => {
        selectList.push(i.tag_id)
      })
      this.tag_list = selectList
    },
    searchButton() {},
    // 编辑内容
    clickButtonEditor(value) {
      // console.log(value)

      this.$router.push({
        name: 'modify_content',
        params: {
          componentName: '修改内容',
          content_type: value.type,
          content_id: value.id,
        },
      })
      // 跳转路由到
    },
    // 获取所有内容标签
    getAllContentTag() {
      this.$http.get('/traver/get_content_tag').then((res) => {
        const { errno, errmsg, tag_list } = res.data
        if (errno == '0') {
          this.contentTags = tag_list
          // console.log(this.contentTags)
        } else {
          this.$message({
            message: errmsg,
            type: 'warning',
          })
        }
      })
    },
    // 获取内容列表
    getContentList() {
      this.$http
        .get(
          `/traver/get_content_list?title=${this.searchContentKeyword}&dest=${this.dest}&tag=${this.tag_list}&p_num=${this.pagenum_system}&p_size=${this.pagesize}`
        )
        .then((res) => {
          // console.log(res)
          this.page_account = res.data.item_account
          if (res.data.errno == '0') {
            let list = res.data.content
            list.forEach((i) => {
              let item = {
                id: i.id,
                title: i.title,
                title_mini: i.introduce,
                image: i.cover_image,
                corner_name: i.dest,
                tag: i.tag,
                update_time: i.update_time,
                type: i.type,
              }
              this.content_list.push(item)
            })
            this.loading = false
          }
        })
    },
    //   创建迹点
    creatNewTraverContent() {
      this.$router.push({ name: 'creat_content' })
    },
  },
}
</script>

<style>
.filter-area {
  display: flex;
}
.filter-area-tag {
  margin-top: 20px;
}
.pagination {
  text-align: right;
  margin-top: 10px;
}
</style>